module.exports = __webpack_public_path__ + "img/OFFROAD.45f5eac.jpg";